/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useMemo } from 'react';
import clsx from 'clsx';
import styles from './LettingHubCardBase.module.scss';
import { useScreenWidth } from '../../../utils/useScreenWidth';
export var LettingHubCardVariant;
(function (LettingHubCardVariant) {
    LettingHubCardVariant["default"] = "Default";
    LettingHubCardVariant["fillContainer"] = "FillContainer";
})(LettingHubCardVariant || (LettingHubCardVariant = {}));
export const LettingHubCardBase = ({ title, description, variant = LettingHubCardVariant.default, backgroundImageMobile, backgroundImageDesktop, onClick, }) => {
    const isMobile = useScreenWidth(500);
    const backgroundImage = useMemo(() => {
        return isMobile ? backgroundImageMobile : backgroundImageDesktop;
    }, [isMobile, backgroundImageMobile, backgroundImageDesktop]);
    const descriptionHtml = { __html: description };
    return (<div className={clsx(styles.lettingHubCardBase, styles[`variant${variant}`])} style={{ backgroundImage: `url(${backgroundImage})` }} onClick={onClick} role='button' tabIndex={0}>
      <div className={styles.innerCard}>
        <div className={styles.titleContainer}>
          <h3>{title}</h3>
          <img src='https://www.haven.com/assets/icons/chevron-b-right.svg' alt='Chevron right'/>
        </div>
        <div dangerouslySetInnerHTML={descriptionHtml}></div>
      </div>
    </div>);
};
